import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Header from '../common/Header';
import Loader from '../Parts/Loader';
import InvalidAuthoritySection from './sections/InvalidAuthoritySection';
import GoBackAndLatestStatusSection from './sections/GoBackAndLatestStatusSection';
import KeymanIntroductionSection from './sections/KeymanIntroductionSection';
import TimelineStatusesSection from './sections/TimelineStatusesSection';
import CustomStatusDialog from './dialogs/CustomStatusDialog';
import LetterOrderCompleteDialog from './dialogs/LetterOrderCompleteDialog';
import FollowCallOrderCompleteDialog from './dialogs/FollowCallOrderCompleteDialog';
import LetterOrderDetailDialog from './dialogs/LetterOrderDetailDialog';
import FollowCallDetailDialog from './dialogs/FollowCallDetailDialog';
import NotificationBar from '../Parts/NotificationBar.jsx'
import ExecDetailItemDialog from '../ExecutiveList/dialogs/ExecDetailItemDialog/ExecDetailItemDialog';
import PromotePlanChangeDialog from '../common/PromotePlanChangeDialog';
import { DialogType, DashboardTimelineType, PromotePlanDialogTypes } from '../../constants/ComponentTypes';
import { isEnabledUserRole } from '../../utils/utils';

const styles = () => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
  },

  main: {
    background: "#F4F6F9",
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
  },
});

class Timeline extends React.Component {
  state = {
    selectedStatus: null,
    showEditStatusDialog: false,
    showAddStatusDialog: false,
    hasFollowCallOrderAddress: false,
    showNotification: false,
    showLetterOrderDetailDialog: false,
    showFollowCallDetailDialog: false,
    showExecDetailItemDialog: false,
    showLetterOrderCompleteDialog: false,
    showFollowCallOrderCompleteDialog: false,
    [PromotePlanDialogTypes.DEPARTMENT_TEL.flag]: false,
    message: '',
    messageType: 'green',
    statusItem: null,
  }

  componentDidMount() {
    // ユーザー情報取得
    this.props.getUserInfo();
    // キーマンデータベースであれば、キーマンデータベースのデータを取得
    if (this.props.isExeTimeline) {
      this.props.getExecutiveListByExecutivePersonId(Number(this.props.match.params.id)) //params.idだとstring型で reducersのexecutiveDetail.jsでマッチしなくなるためNumberでキャスト
    } else {
      this.props.getAddressById(Number(this.props.match.params.id))
    }
    // タイムラインを取得
    let query = this.buildQuery({}, this.props);
    this.props.getTimelineStatus(this.props.match.params.id, query);

    // 注文後であれば、ダイアログを表示
    if (this.props.routerInfo.state) {
      if (this.props.routerInfo.state.orderComplete) {
        this.toggleOrderCompleteDialog();
      } else if (this.props.routerInfo.state.followCallOrderComplete) {
        this.toggleFollowCallOrderCompleteDialog();
      }
    }
  }

  // TODO componentDidUpdateだとタイムラインを編集->保存するとエラー
  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      // 同一ルート内でIDだけ変わった場合はコンポーネントが再マウントされないため、キーマン情報も取得し直す
      if (nextProps.isExeTimeline) {
        nextProps.getExecutiveListByExecutivePersonId(Number(nextProps.match.params.id));
      } else {
        nextProps.getAddressById(Number(nextProps.match.params.id));
      }
      nextProps.getTimelineStatus(nextProps.match.params.id, this.buildQuery({}, nextProps));
    }

    if (nextProps.successMessage && nextProps.successMessage !== '') {
      this.displayNotification(nextProps.successMessage, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== '') {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== '') {
      this.displayNotification(nextProps.shortMessage, "green");
    }
  }

  toggleEditStatusDialog = (statusItem = null, hasFollowCallOrderAddress = false) => {
    this.setState({
      showEditStatusDialog: !this.state.showEditStatusDialog,
      statusItem: statusItem,
      hasFollowCallOrderAddress: hasFollowCallOrderAddress,
    });
  }

  toggleAddStatusDialog = (hasFollowCallOrderAddress = false) => {
    this.setState({
      showAddStatusDialog: !this.state.showAddStatusDialog,
      hasFollowCallOrderAddress: hasFollowCallOrderAddress,
    });
  }

  toggleOrderCompleteDialog = () => {
    this.setState({ showLetterOrderCompleteDialog: !this.state.showLetterOrderCompleteDialog });
  }

  toggleFollowCallOrderCompleteDialog = () => {
    this.setState({ showFollowCallOrderCompleteDialog: !this.state.showFollowCallOrderCompleteDialog });
  }

  toggleLetterOrderDetailDialog = (status = null) => {
    this.setState({
      showLetterOrderDetailDialog: !this.state.showLetterOrderDetailDialog,
      selectedStatus: status
    });
  }

  toggleFollowCallDetailDialog = (status = null) => {
    this.setState({
      showFollowCallDetailDialog: !this.state.showFollowCallDetailDialog,
      selectedStatus: status
    });
  }

  toggleExecDetailItemDialog = () => {
    this.setState({
      showExecDetailItemDialog: !this.state.showExecDetailItemDialog,
    });
  }

  togglePromotePlanChangeDialog = (type) => {
    this.setState({
      [type["flag"]]: !(this.state[type["flag"]])
    });
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    })
  };

  handleSaveStatus = (data = {}) => {
    this.props.postTimelineStatus(
      this.props.match.params.id,
      this.buildQuery(data, this.props)
    )
  }

  goBack = () => {
    // TODO 処理が怪しいので、後で見直す
    const { routerInfo } = this.props;
    if (routerInfo.state && routerInfo.state.pathname) {
      this.props.goTo(routerInfo.state.pathname, routerInfo.state);
    } else if (routerInfo.state && routerInfo.state.hasOwnProperty("isExeDetail")) {
      this.props.goTo(`/executive-list`, {
        query: routerInfo.state.query,
        filter: routerInfo.state.filter,
        item: routerInfo.state.item,
        filterValue: this.props.routerInfo.state.filterValue,
      });
    } else if (routerInfo.state && routerInfo.state.hasOwnProperty("ownerType") && routerInfo.state.hasOwnProperty("statusSelected") && routerInfo.state.hasOwnProperty("dateSelectedValue")) {
      this.props.goTo('/order-dashboard' + DashboardTimelineType.BY_FOLLOW_CALL_STATUS.path, {
        ownerType: routerInfo.state.ownerType,
        statusSelected: routerInfo.state.statusSelected,
        dateSelectedValue: routerInfo.state.dateSelectedValue,
        keyword: routerInfo.state.keyword
      })
    } else if (routerInfo.state && routerInfo.state.hasOwnProperty("ownerType") && routerInfo.state.hasOwnProperty("dateSelectedValue") && routerInfo.state.hasOwnProperty("path")) {
      this.props.goTo(routerInfo.state.path, {
        ownerType: routerInfo.state.ownerType,
        dateSelectedValue: routerInfo.state.dateSelectedValue,
        keyword: routerInfo.state.keyword
      })
    } else {
      this.props.goBack();
    }
  };

  /*** helper functions ***/
  // URLのパラメータを付与してるので、下層に移譲しにくいので、タイムラインの追加・編集・一覧取得はこのファイルでおこなっています。
  buildQuery = (data = {}, props) => {
    let query = data;
    if (props.isExeTimeline) {
      query['executive_person_id'] = props.match.params.id;
    } else {
      query['address_id'] = props.match.params.id;
    }

    return query;
  }

  renderCustomStatusDialog = () => {
    if (this.state.showAddStatusDialog || this.state.showEditStatusDialog) {
      const isAdd = this.state.showAddStatusDialog;
      return (
        <CustomStatusDialog
          type={isAdd ? DialogType.CREATE : DialogType.EDIT}
          isOpen={isAdd ? this.state.showAddStatusDialog : this.state.showEditStatusDialog}
          toggleDialog={isAdd ? this.toggleAddStatusDialog : this.toggleEditStatusDialog}
          hasFollowCallAddress={isAdd ? this.state.hasFollowCallOrderAddress : this.state.hasFollowCallOrderAddress}
          item={isAdd ? null : this.state.statusItem}
          save={this.handleSaveStatus}
        />
      );
    }
  }

  renderOrderCompleteDialog = () => {
    if (this.state.showLetterOrderCompleteDialog) {
      return (
        <LetterOrderCompleteDialog
          isOpen={this.state.showLetterOrderCompleteDialog}
          toggleDialog={this.toggleOrderCompleteDialog}
          time={(this.props.routerInfo && this.props.routerInfo.state) ? this.props.routerInfo.state.orderTime : ''}
          orderScheduledAt={(this.props.routerInfo && this.props.routerInfo.state) ? this.props.routerInfo.state.orderScheduledAt : ''}
        />
      );
    }
  }

  renderFollowCallOrderCompleteDialog = () => {
    if (this.state.showFollowCallOrderCompleteDialog) {
      return (
        <FollowCallOrderCompleteDialog
          isOpen={this.state.showFollowCallOrderCompleteDialog}
          toggleDialog={this.toggleFollowCallOrderCompleteDialog}
        />
      );
    }
  }

  renderLetterOrderDetailDialog = () => {
    if (this.state.showLetterOrderDetailDialog) {
      return (
        <LetterOrderDetailDialog
          isOpen={this.state.showLetterOrderDetailDialog}
          toggleDialog={this.toggleLetterOrderDetailDialog}
          status={this.state.selectedStatus}
        />
      );
    }
  }

  renderFollowCallDetailDialog = () => {
    if (this.state.showFollowCallDetailDialog) {
      return (
        <FollowCallDetailDialog
          isOpen={this.state.showFollowCallDetailDialog}
          toggleDialog={this.toggleFollowCallDetailDialog}
          status={this.state.selectedStatus}
          statuses={this.props.statuses}
        />
      );
    }
  }

  renderExecDetailItemDialog = () => {
    if (this.props.isExeTimeline && this.state.showExecDetailItemDialog && !!this.props.keymanItem) {
      // ExecDetailItemDialogコンポーネントのさらに下層のコンポーネントの各プロパティをまとめる（可読性のため）
      const executivePersonProps = {
        isLoadingExecutiveListItem: this.props.isLoadingKeymanItem,
        executiveListItem: this.props.keymanItem,
        filterIntentKeywords: [],
      }
      const timelineProps = {
        goToTimeline: null,
      }

      // ExecDetailItemDialogコンポーネントのコンポーネントの各プロパティをまとめる（可読性のため）
      const corporationRelationshipsKeymanProps = {
        handleFilterRivalKeyman: null,
        handleFilterChildCorporationKeyman: null,
        handleFilterParentCorporationKeyman: null
      };

      // ExecDetailItemDialogコンポーネントのさらに下層のコンポーネントの各プロパティをまとめる（可読性のため）
      const csvProps = {
        overview: this.props.overview,
        toggleCsvDownloadDialog: null,
      }

      return (
        <ExecDetailItemDialog
          user={this.props.user}
          isOpen={this.state.showExecDetailItemDialog && !!this.props.keymanItem}
          toggleDialog={this.toggleExecDetailItemDialog}
          toggleEditTagsDialog={null}
          togglePromotePlanChangeDialog={($type) => this.togglePromotePlanChangeDialog($type)}
          goToSendLetter={null}
          {...executivePersonProps}
          {...timelineProps}
          {...corporationRelationshipsKeymanProps}
          {...csvProps}
        />
      );
    }
  }

  renderPromotePlanChangeDialog = (type) => {
    if (this.state[type["flag"]]) {
      return (
        <PromotePlanChangeDialog
          isOpen={this.state[type["flag"]]}
          type={type}
          toggleDialog={() => this.togglePromotePlanChangeDialog(type)}
          handlePlanChange={this.togglePlanDialog}
        />
      );
    }
  }

  renderNotification = () => {
    if (this.state.showNotification) {
      return (
        <div style={{ position: 'fixed', zIndex: 10000, top: 10, width: '98%', left: '1%' }}>
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={() => {
              this.setState({ showNotification: false })
            }}
            autoClose={false}
            style={{
              width: this.state.messageType === "green" ? "fit-content" : '100%',
            }}
          >
          </NotificationBar>
        </div>
      );
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Header title="タイムライン" type="dark" hasBackBtn={false} />
        <div className={classes.main}>
          {(() => {
            // ローダーが回りっぱなしにならないようにローダーより前に権限チェックを行う
            if (
              (this.props.user && this.props.isExeTimeline && !isEnabledUserRole(this.props.user, "executive-list", "read")) ||
              (this.props.user && !this.props.isExeTimeline && !isEnabledUserRole(this.props.user, "house-list", "read"))
            ) {
              return <InvalidAuthoritySection />;
            } else if (this.props.isLoadingStatuses || this.props.isLoadingKeymanItem) {
              return <Loader type="color" size="large" />;
            } else {
              return <React.Fragment>
                <GoBackAndLatestStatusSection
                  goBack={this.goBack}
                />
                <KeymanIntroductionSection
                  toggleLetterOrderDetailDialog={this.toggleLetterOrderDetailDialog}
                  toggleExecDetailItemDialog={this.toggleExecDetailItemDialog}
                />
                <TimelineStatusesSection
                  toggleAddStatusDialog={this.toggleAddStatusDialog}
                  toggleEditStatusDialog={this.toggleEditStatusDialog}
                  toggleLetterOrderDetailDialog={this.toggleLetterOrderDetailDialog}
                  toggleFollowCallDetailDialog={this.toggleFollowCallDetailDialog}
                />
              </React.Fragment>;
            }
          })()}
        </div>

        {this.renderCustomStatusDialog()}
        {this.renderLetterOrderDetailDialog()}
        {this.renderFollowCallDetailDialog()}
        {this.renderExecDetailItemDialog()}
        {this.renderOrderCompleteDialog()}
        {this.renderFollowCallOrderCompleteDialog()}
        {this.renderNotification()}
        {this.renderPromotePlanChangeDialog(PromotePlanDialogTypes.DEPARTMENT_TEL)}
      </div>
    );
  }
}

Timeline.propTypes = {
  classes: PropTypes.object.isRequired,
  isExeTimeline: PropTypes.bool,
  statuses: PropTypes.array,
  isLoadingStatuses: PropTypes.bool,
  overview: PropTypes.object,
  isLoadingKeymanItem: PropTypes.bool,
  keymanItem: PropTypes.object,
  user: PropTypes.object,
  errorMessage: PropTypes.string,
  successMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  routerInfo: PropTypes.object,
  goBack: PropTypes.func,
  goTo: PropTypes.func,
  getUserInfo: PropTypes.func,
  getTimelineStatus: PropTypes.func,
  getAddressById: PropTypes.func,
  getExecutiveListByExecutivePersonId: PropTypes.func,
  postTimelineStatus: PropTypes.func,
  match: PropTypes.object,
};

export default withStyles(styles)(Timeline);



// WEBPACK FOOTER //
// ./src/components/Timeline/Timeline.jsx